import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../components/Navbar/Navbar';
import NavbarAdmin from '../components/Navbar/NavbarAdmin';
import Sidebar from '../components/Sidebar/Sidebar';
import SidebarAdmin from '../components/Sidebar/SidebarAdmin';
import ButtomBar from '../components/Sidebar/BottomBar';
import { ROLES } from '../utils/constants';

function DashboardLayout({ checkAccessRights }) {
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const handleOnMobileNavOpen = () => {
    setMobileNavOpen(true);
  };
  const handleOnMobileNavClose = () => {
    setMobileNavOpen(false);
  };
  const renderSidebarFromAccessibleRole = () => {
    if (checkAccessRights(ROLES.USER_ROLE)) {
      return (
        // <div className="container">
        <Sidebar
          onMobileClose={handleOnMobileNavClose}
          openMobile={isMobileNavOpen}
        >
          <Outlet />
          <ButtomBar />
        </Sidebar>
        // </div>
      );
    }
    if (checkAccessRights(ROLES.ADMIN_ROLE) || checkAccessRights(ROLES.SUPER_ADMIN_ROLE)) {
      /* ADMIN LAYOUT */
      return (
        // <div className="container">
        <SidebarAdmin
          onMobileClose={handleOnMobileNavClose}
          openMobile={isMobileNavOpen}
        >
          <Outlet />
        </SidebarAdmin>
        // </div>
      );
    }
    return <></>;
  };

  const renderNavbarFromAccessibleRole = () => {
    if (checkAccessRights(ROLES.USER_ROLE)) {
      return (
        // <div className="container">
        <Navbar
          openMobile={isMobileNavOpen}
          onMobileNavOpen={handleOnMobileNavOpen}
          onMobileNavClose={handleOnMobileNavClose}
        />
        // </div>
      );
    }
    if (checkAccessRights(ROLES.ADMIN_ROLE) || checkAccessRights(ROLES.SUPER_ADMIN_ROLE)) {
      /* ADMIN LAYOUT */
      return (
        <NavbarAdmin
          openMobile={isMobileNavOpen}
          onMobileNavOpen={handleOnMobileNavOpen}
          onMobileNavClose={handleOnMobileNavClose}
        />
      );
    }
    return <></>;
  };
  return (
    <div className="w-[100vw] h-[100vh]">
      {renderNavbarFromAccessibleRole()}
      {renderSidebarFromAccessibleRole()}
    </div>
  );
}

export default DashboardLayout;
